// import React, { useState, useEffect } from "react";
// import { getPublicNotice } from "../api/noticeBoardApi";

// const NoticeBoard = ({ className = "" }) => {
//   const [notice, setNotice] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchNotice = async () => {
//     setLoading(true);
//     try {
//       const res = await getPublicNotice();
//       const list = Array.isArray(res?.data) ? res.data : [];
//       setNotice(res?.success ? list : []);
//     } catch {
//       setNotice([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNotice();
//   }, []);

//   return (
//     <div
//       className={`ds-card ds-dash-panel overflow-hidden flex flex-col w-full h-full min-h-[160px] ${className}`.trim()}
//     >
//       <h3 className="text-[14px] font-semibold text-[var(--text-dark)] mb-2 shrink-0">
//         Notice Board
//       </h3>

//       <div className="overflow-y-auto flex-1 min-h-0 pr-1 ds-scroll notice-board-content">
//         {loading ? (
//           <p className="text-[12px] text-[var(--text-muted)]">Loading notices...</p>
//         ) : notice.length === 0 ? (
//           <p className="text-[12px] text-[var(--text-muted)]">
//             No active notices right now.
//           </p>
//         ) : (
//           notice.map((item, index) => (
//             <div key={item._id || index}>
//               <div
//                 className="text-[12px] text-[var(--text-dark)] leading-snug [&_*]:text-[var(--text-dark)] [&_a]:make-text-primary"
//                 dangerouslySetInnerHTML={{ __html: item.content || "" }}
//               />
//               {index !== notice.length - 1 && (
//                 <div className="border-t border-[var(--border-color)] my-2" />
//               )}
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default NoticeBoard;


// import React, { useEffect, useState } from "react";
// import { getPublicNotice } from "../api/noticeBoardApi";

// const NoticeBoard = ({ className = "", onNoticeStatusChange }) => {
//   const [notice, setNotice] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchNotice = async () => {
//     setLoading(true);

//     try {
//       const res = await getPublicNotice();
//       const list = Array.isArray(res?.data) ? res.data : [];

//       const activeNotices = res?.success ? list : [];

//       setNotice(activeNotices);

//       // Parent ko notice available hai ya nahi batayenge
//       onNoticeStatusChange?.(activeNotices.length > 0);
//     } catch {
//       setNotice([]);
//       onNoticeStatusChange?.(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchNotice();
//   }, []);

//   // Loading ke time optionally box show kar sakte ho.
//   // Loading complete hone ke baad notice nahi hai to pura component hide.
//   if (!loading && notice.length === 0) {
//     return null;
//   }

//   return (
//     <div
//       className={`ds-card ds-dash-panel overflow-y-auto flex flex-col w-full h-full min-h-[160px] ${className}`.trim()}
//     >
//       <h3 className="text-[14px] font-semibold text-[var(--text-dark)] mb-2 shrink-0">
//         Notice Board
//       </h3>

//       <div className="overflow-y-auto flex-1 min-h-0 pr-1 ds-scroll notice-board-content">
//         {loading ? (
//           <p className="text-[12px] text-[var(--text-muted)]">
//             Loading notices...
//           </p>
//         ) : (
//           notice.map((item, index) => (
//             <div key={item._id || index}>
//               <div
//                 className="text-[12px] text-[var(--text-dark)] overflow-y-auto leading-snug [&_*]:text-[var(--text-dark)] [&_a]:make-text-primary"
//                 dangerouslySetInnerHTML={{
//                   __html: item.content || "",
//                 }}
//               />

//               {index !== notice.length - 1 && (
//                 <div className="border-t border-[var(--border-color)] my-2" />
//               )}
//             </div>
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default NoticeBoard;



import React, { useEffect, useState } from "react";
import { getPublicNotice } from "../api/noticeBoardApi";

const NoticeBoard = ({ className = "", onNoticeStatusChange }) => {
  const [notice, setNotice] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotice = async () => {
    setLoading(true);

    try {
      const res = await getPublicNotice();
      const list = Array.isArray(res?.data) ? res.data : [];
      console.log("get the notice",res)
      const activeNotices = res?.success ? list : [];

      setNotice(activeNotices);
      onNoticeStatusChange?.(activeNotices.length > 0);
    } catch {
      setNotice([]);
      onNoticeStatusChange?.(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  if (!loading && notice.length === 0) {
    return null;
  }

  return (
    <div
      className={`
        ds-card
        ds-dash-panel
        flex
        flex-col
        w-full
        h-[160px]
        min-h-[184px]
        max-h-[160px]
        overflow-hidden
        ${className}
      `.trim()}
    >
      <h3 className="text-[14px] font-semibold text-[var(--text-dark)] mb-2 shrink-0">
      {notice?.[0]?.title ??  "Notice Board"}  
      </h3>

      <div className="flex-1 min-h-0 overflow-y-auto pr-1 ds-scroll notice-board-content">
        {loading ? (
          <p className="text-[12px] text-[var(--text-muted)]">
            Loading notices...
          </p>
        ) : (
          notice.map((item, index) => (
            <div key={item._id || index}>
              <div
                className="
                  text-[12px]
                  text-[var(--text-dark)]
                  leading-relaxed
                  break-words
                  [&_*]:text-[var(--text-dark)]
                  [&_a]:make-text-primary
                "
                dangerouslySetInnerHTML={{
                  __html: item.content || "",
                }}
              />

              {index !== notice.length - 1 && (
                <div className="border-t border-[var(--border-color)] my-2" />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NoticeBoard;
